import React from 'react'

export const phoneIcon = <svg version="1.1" className="phoneIcon" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 16 16" enableBackground="new 0 0 16 16;" xmlSpace="preserve">
	<g id="Group_3984" transform="translate(1787 -4216)">
		<path id="Path_506" className="st0" d="M-1781.8,4223c0.8,1.6,2.1,2.9,3.7,3.7l1.2-1.2c0.1-0.1,0.4-0.2,0.6-0.1c0.6,0.2,1.3,0.3,2,0.3
			c0.3,0,0.6,0.2,0.6,0.6v1.9c0,0.3-0.2,0.6-0.6,0.6c-5.2,0-9.4-4.2-9.4-9.4c0,0,0,0,0,0c0-0.3,0.2-0.6,0.6-0.6h1.9
			c0.3,0,0.6,0.2,0.6,0.6c0,0.7,0.1,1.3,0.3,2c0.1,0.2,0,0.4-0.1,0.6L-1781.8,4223z"/>
	</g>
</svg>

export const SendMessageIcon = (props) => (<svg xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 24.166 23.19">
	<g id="Grupo_19307" data-name="Grupo 19307" transform="translate(0 9.333) rotate(-30)">
	<g id="Grupo_984" data-name="Grupo 984" transform="translate(0 0)">
		<path id="Trazado_570" data-name="Trazado 570" d="M.009,0,0,6.222,13.333,8,0,9.778.009,16,18.667,8Z" transform="translate(0 0)" fill={props.fill}/>
	</g>
	</g>
</svg>)


export const cellICon = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<g id="Icon-11" opacity="0.401">
  <path id="Trazado_42" data-name="Trazado 42" d="M68.083,20H61.917A1.919,1.919,0,0,0,60,21.917V34.75a1.919,1.919,0,0,0,1.917,1.917h6.167A1.919,1.919,0,0,0,70,34.75V21.917A1.919,1.919,0,0,0,68.083,20ZM65,35.833A.833.833,0,1,1,65.833,35,.833.833,0,0,1,65,35.833Zm3.333-2.917a.417.417,0,0,1-.417.417H62.083a.417.417,0,0,1-.417-.417V22.083a.417.417,0,0,1,.417-.417h1.25l.833.833h1.667l.833-.833h1.25a.417.417,0,0,1,.417.417Z" transform="translate(-55 -18.333)"/>
  <rect id="Rectángulo_21" data-name="Rectángulo 21" width="20" height="20" fill="rgba(255,255,255,0)"/>
</g>
</svg>

export const iconList = <svg id="Icon-list" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
<path id="Unión_16" data-name="Unión 16" d="M0,11.666a1.667,1.667,0,1,1,1.667,1.667A1.667,1.667,0,0,1,0,11.666Zm6.25,1.25a1.25,1.25,0,0,1,0-2.5h9.167a1.25,1.25,0,0,1,0,2.5ZM0,6.667A1.667,1.667,0,1,1,1.667,8.333,1.666,1.666,0,0,1,0,6.667Zm6.25,1.25a1.25,1.25,0,0,1,0-2.5h9.167a1.25,1.25,0,0,1,0,2.5ZM0,1.666A1.667,1.667,0,1,1,1.667,3.333,1.667,1.667,0,0,1,0,1.666Zm6.25,1.25a1.25,1.25,0,0,1,0-2.5h9.167a1.25,1.25,0,0,1,0,2.5Z" transform="translate(1.667 3.333)" fill="#4b4b4b" stroke="rgba(0,0,0,0)" stroke-width="1"/>
<rect id="Rectángulo_10938" data-name="Rectángulo 10938" width="20" height="20" fill="none"/>
</svg>


export const CellIConAlert = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={props.width ? props.width : "20"} height={props.height ? props.height : "20"} viewBox="0 0 20 20">
		<g id="Icon-11" opacity={props.opacity ? props.opacity : "0.401"}>
		<path fill={props.fill} id="Trazado_42" data-name="Trazado 42" d="M68.083,20H61.917A1.919,1.919,0,0,0,60,21.917V34.75a1.919,1.919,0,0,0,1.917,1.917h6.167A1.919,1.919,0,0,0,70,34.75V21.917A1.919,1.919,0,0,0,68.083,20ZM65,35.833A.833.833,0,1,1,65.833,35,.833.833,0,0,1,65,35.833Zm3.333-2.917a.417.417,0,0,1-.417.417H62.083a.417.417,0,0,1-.417-.417V22.083a.417.417,0,0,1,.417-.417h1.25l.833.833h1.667l.833-.833h1.25a.417.417,0,0,1,.417.417Z" transform="translate(-55 -18.333)"/>
		<rect id="Rectángulo_21" data-name="Rectángulo 21" width="20" height="20" fill={"rgba(255,255,255,0)"}/>
		</g>
	</svg>
)

export const ZtoA = <svg version="1.1" className="orderSVG" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 10.8 12" enableBackground="new 0 0 10.8 12;" xmlSpace="preserve">
<g id="Group_3897" transform="translate(-13337 -13247)" className="st0">
	<path id="Path_2033" d="M13340.5,13247.2h-1.8v8.7h-1.6l2.6,2.9l2.6-2.8l-1.7,0V13247.2z"/>
	<path id="Path_2034" d="M13345.7,13253.9h-0.7l-2,5.1h0.8l0.4-1.1h2.3l0.4,1.1h0.8L13345.7,13253.9z M13344.5,13257.2l0.9-2.3
		l0.9,2.3H13344.5z"/>
	<path id="Path_2035" d="M13344.5,13251.4h2.7v0.7h-3.8v-0.5l2.6-3.8h-2.6v-0.7h3.7v0.5L13344.5,13251.4z"/>
</g>
</svg>

export const AtoZ = <svg version="1.1" className="orderSVG" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 10.6 12" enableBackground="new 0 0 10.6 12;" xmlSpace="preserve">
<g id="Group_3900" transform="translate(-13477 -13286)" className="st0">
	<path id="Path_2026" d="M13480.4,13286.3h-1.8v8.6h-1.6l2.6,2.8l2.5-2.8h-1.7V13286.3z"/>
	<path id="Path_2027" d="M13485.6,13286h-0.7l-2,5.1h0.8l0.4-1.1h2.3l0.4,1.1h0.8L13485.6,13286z M13484.4,13289.3l0.9-2.3l0.9,2.3
		H13484.4z"/>
	<path id="Path_2028" d="M13484.4,13297.3h2.7v0.7h-3.8v-0.6l2.6-3.8h-2.6v-0.7h3.6v0.5L13484.4,13297.3z"/>
</g>
</svg>

export const manualCallSvg = <svg version="1.1" className="manualCallSvg" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xlinkHref="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" height="100%" viewBox="0 0 40 40" enableBackground="new 0 0 40 40" xmlSpace="preserve">
<g>
	<linearGradient id="SVGID_3_" gradientUnits="userSpaceOnUse" x1="11.3789" y1="5.9849" x2="11.3789" y2="32.6956">
		<stop  offset="0" style={{stopColor:"#00EB0F"}}/>
		<stop  offset="0.3085" style={{stopColor:"#05D311"}}/>
		<stop  offset="0.7492" style={{stopColor:"#0CB512"}}/>
		<stop  offset="1" style={{stopColor:"#0EAA13"}}/>
	</linearGradient>
	<path fill="url(#SVGID_3_)" d="M9.135,14.316c-1.197,3.68-1.189,7.67,0,11.359h3.792c0.464,0,0.889,0.268,1.087,0.672l2.586,3.57
		c0.474,0.473,0.474,1.249,0,1.723l-3.009,3.01c-0.474,0.474-1.25,0.474-1.724,0c-8.096-8.096-8.096-21.214,0-29.309
		c0.474-0.473,1.25-0.473,1.724,0l3.018,3.019c0.472,0.474,0.472,1.249,0,1.724l-2.587,3.568c-0.206,0.396-0.612,0.664-1.095,0.664
		H9.135z"/>
	<linearGradient id="SVGID_9_" gradientUnits="userSpaceOnUse" x1="32.2051" y1="13.8291" x2="28.759" y2="9.1206">
		<stop  offset="0" style={{stopColor:"#F2F2F2"}}/>
		<stop  offset="0.3881" style={{stopColor:"#F9F9F9"}}/>
		<stop  offset="1" style={{stopColor:"#FFFFFF"}}/>
	</linearGradient>
	<path fill="url(#SVGID_9_)" d="M33,12.629C33,13.386,32.386,14,31.628,14h-2.256C28.614,14,28,13.386,28,12.629v-2.258
		C28,9.614,28.614,9,29.372,9h2.256C32.386,9,33,9.614,33,10.371V12.629z"/>
	<linearGradient id="SVGID_10_" gradientUnits="userSpaceOnUse" x1="24.2041" y1="13.8281" x2="20.758" y2="9.1196">
		<stop  offset="0" style={{stopColor:"#F2F2F2"}}/>
		<stop  offset="0.3881" style={{stopColor:"#F9F9F9"}}/>
		<stop  offset="1" style={{stopColor:"#FFFFFF"}}/>
	</linearGradient>
	<path fill="url(#SVGID_10_)" d="M25,12.629C25,13.386,24.386,14,23.628,14h-2.256C20.614,14,20,13.386,20,12.629v-2.258
		C20,9.614,20.614,9,21.372,9h2.256C24.386,9,25,9.614,25,10.371V12.629z"/>
	<linearGradient id="SVGID_4_" gradientUnits="userSpaceOnUse" x1="32.2051" y1="21.8301" x2="28.7578" y2="17.12">
		<stop  offset="0" style={{stopColor:"#F2F2F2"}}/>
		<stop  offset="0.3881" style={{stopColor:"#F9F9F9"}}/>
		<stop  offset="1" style={{stopColor:"#FFFFFF"}}/>
	</linearGradient>
	<path fill="url(#SVGID_4_)" d="M33,20.629C33,21.387,32.386,22,31.628,22h-2.256C28.614,22,28,21.387,28,20.629v-2.258
		C28,17.613,28.614,17,29.372,17h2.256C32.386,17,33,17.613,33,18.371V20.629z"/>
	<linearGradient id="SVGID_5_" gradientUnits="userSpaceOnUse" x1="24.2051" y1="21.8301" x2="20.7578" y2="17.12">
		<stop  offset="0" style={{stopColor:"#F2F2F2"}}/>
		<stop  offset="0.3881" style={{stopColor:"#F9F9F9"}}/>
		<stop  offset="1" style={{stopColor:"#FFFFFF"}}/>
	</linearGradient>
	<path fill="url(#SVGID_5_)" d="M25,20.629C25,21.387,24.386,22,23.628,22h-2.256C20.614,22,20,21.387,20,20.629v-2.258
		C20,17.613,20.614,17,21.372,17h2.256C24.386,17,25,17.613,25,18.371V20.629z"/>
	<linearGradient id="SVGID_6_" gradientUnits="userSpaceOnUse" x1="24.2051" y1="29.8291" x2="20.759" y2="25.1206">
		<stop  offset="0" style={{stopColor:"#F2F2F2"}}/>
		<stop  offset="0.3881" style={{stopColor:"#F9F9F9"}}/>
		<stop  offset="1" style={{stopColor:"#FFFFFF"}}/>
	</linearGradient>
	<path fill="url(#SVGID_6_)" d="M25,28.629C25,29.387,24.386,30,23.628,30h-2.256C20.614,30,20,29.387,20,28.629v-2.258
		C20,25.613,20.614,25,21.372,25h2.256C24.386,25,25,25.613,25,26.371V28.629z"/>
	<linearGradient id="SVGID_7_" gradientUnits="userSpaceOnUse" x1="16.2041" y1="21.8291" x2="12.7574" y2="17.1198">
		<stop  offset="0" style={{stopColor:"#F2F2F2"}}/>
		<stop  offset="0.3881" style={{stopColor:"#F9F9F9"}}/>
		<stop  offset="1" style={{stopColor:"#FFFFFF"}}/>
	</linearGradient>
	<path fill="url(#SVGID_7_)" d="M17,20.629C17,21.387,16.386,22,15.628,22h-2.256C12.614,22,12,21.387,12,20.629v-2.258
		C12,17.613,12.614,17,13.372,17h2.256C16.386,17,17,17.613,17,18.371V20.629z"/>
	<linearGradient id="SVGID_8_" gradientUnits="userSpaceOnUse" x1="32.2051" y1="29.8291" x2="28.759" y2="25.1206">
		<stop  offset="0" style={{stopColor:"#F2F2F2"}}/>
		<stop  offset="0.3881" style={{stopColor:"#F9F9F9"}}/>
		<stop  offset="1" style={{stopColor:"#FFFFFF"}}/>
	</linearGradient>
	<path fill="url(#SVGID_8_)" d="M33,28.629C33,29.386,32.386,30,31.628,30h-2.256C28.614,30,28,29.386,28,28.629v-2.258
		C28,25.614,28.614,25,29.372,25h2.256C32.386,25,33,25.614,33,26.371V28.629z"/>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>


// WEBPACK FOOTER //
// ./src/Images/ManualCallSVG.js